/**
 * Errors related to invalid open invitation state values or transitions.
 */

import { InternalServerError } from "./base.error.js";

export class InvalidOpenInvitationStateError extends InternalServerError {
  constructor(invalidValue: string) {
    super(
      `Invalid open invitation state: "${invalidValue}". Valid states: ACTIVE, DISABLED, EXPIRED, EXHAUSTED`,
    );
    Object.defineProperty(this, "name", {
      value: "InvalidOpenInvitationStateError",
    });
  }
}

/**
 * Error thrown when an invalid open invitation state transition is attempted
 * @example
 * throw new InvalidOpenInvitationStateTransitionError("oin_abc123", "DISABLED", "EXHAUSTED");
 * // "Cannot transition OpenInvitation 'oin_abc123' from DISABLED to EXHAUSTED"
 */
export class InvalidOpenInvitationStateTransitionError extends InternalServerError {
  constructor(
    public readonly openInvitationId: string,
    public readonly currentState: string,
    public readonly targetState: string,
  ) {
    super(
      `Cannot transition OpenInvitation '${openInvitationId}' from ${currentState} to ${targetState}`,
    );
    Object.defineProperty(this, "name", {
      value: "InvalidOpenInvitationStateTransitionError",
    });
  }
}
